/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Export_ButtonInputs */

const en_transcript_export_export_button = /** @type {(inputs: Transcript_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const fr_transcript_export_export_button = /** @type {(inputs: Transcript_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter`)
};

const de_transcript_export_export_button = /** @type {(inputs: Transcript_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const it_transcript_export_export_button = /** @type {(inputs: Transcript_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportare`)
};

const ru_transcript_export_export_button = /** @type {(inputs: Transcript_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт`)
};

const es_transcript_export_export_button = /** @type {(inputs: Transcript_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar`)
};

const zh_cn2_transcript_export_export_button = /** @type {(inputs: Transcript_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口`)
};

const ja_transcript_export_export_button = /** @type {(inputs: Transcript_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸出`)
};

const hi_transcript_export_export_button = /** @type {(inputs: Transcript_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात`)
};

const pt_pt2_transcript_export_export_button = /** @type {(inputs: Transcript_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar`)
};

/**
* | output |
* | --- |
* | "Export" |
*
* @param {Transcript_Export_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_export_button = /** @type {((inputs?: Transcript_Export_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_export_button(inputs)
	if (locale === "de") return de_transcript_export_export_button(inputs)
	if (locale === "it") return it_transcript_export_export_button(inputs)
	if (locale === "ru") return ru_transcript_export_export_button(inputs)
	if (locale === "es") return es_transcript_export_export_button(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_export_button(inputs)
	if (locale === "ja") return ja_transcript_export_export_button(inputs)
	if (locale === "hi") return hi_transcript_export_export_button(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_export_button(inputs)
	return en_transcript_export_export_button(inputs)
});